

function hideMultipleColorOption() {

  const colorTaxonomyId = "gid://shopify/TaxonomyValue/2865";

 //get all #accordion-filter-v-t-shopify-color-pattern and put into an array
 let detailsElements = document.querySelectorAll('#accordion-filter-v-t-shopify-color-pattern');
  if (detailsElements.length === 0) {
    return; // Exit if no elements found
  }
  // Loop through each details element
  detailsElements = Array.from(detailsElements); // Convert NodeList to Array for easier manipulation
  detailsElements.forEach((detailsElement) => {
    // Find div.accordion__content inside the details element
    const accordionContentWrap = detailsElement.querySelector('div.accordion__content div.h-stack.wrap');
    if (accordionContentWrap) {
        // Find all input[type="checkbox"] elements inside the accordion content
        const checkboxes = accordionContentWrap.querySelectorAll('input[type="checkbox"]');
        // Loop through each checkbox and check if it has the data-taxonomy-value-id attribute
          checkboxes.forEach((checkbox) => {
            const taxonomyValueId = checkbox.getAttribute('value');
            // If the taxonomy value ID matches the colorTaxonomyId, hide the checkbox
            if (taxonomyValueId === colorTaxonomyId) {
                // Get the ID of the checkbox
                const checkboxId = checkbox.getAttribute('id');
                // Get the label after the checkbox
                const label = accordionContentWrap.querySelector(`label[for="${checkboxId}"]`);

                // Hide the checkbox and its label
                checkbox.style.display = 'none';
                if (label) {
                    label.style.display = 'none';
                } 

                //delete the checkbox from the DOM
                checkbox.remove();
                //delete the label from the DOM
                if (label) {
                    label.remove();
                }

            }
        });
    }
  });


}


//create as a spearate function to hide availability filter
function hideAvailabilityFilter() {
  //see if #facet-form is present
  const facetForm = document.querySelector('#facet-form');
  if (facetForm) {
    //loop all div.accordion, check if accordion__toggle is inside, then check if it has a input[type="checkbox"] with a name that is filter.v.availability inside - if so, add style="display:none" to the div.accordion
    const accordions = document.querySelectorAll('div.accordion');
    for (let i = 0; i < accordions.length; i++) {
      const accordion = accordions[i];
      const toggle = accordion.querySelector('.accordion__toggle');
      if (toggle) {
        const checkbox = toggle.querySelector('input[type="checkbox"][name="filter.v.availability"]');
        if (checkbox) {
            accordion.style.display = 'none';
        }
      }
    }
  }
}


document.addEventListener('DOMContentLoaded',hideMultipleColorOption);

document.addEventListener('DOMContentLoaded',hideAvailabilityFilter);

document.addEventListener('facet:update',  async (event) => {

  // Get the URL from the event detail
  const url = new URL(event.detail.url, window.location.origin);

  let count_of_search_params = Array.from(url.searchParams.keys()).length;

  //lenght is 1 and it is the availability filter
  if ((count_of_search_params != 2 && url.searchParams.get('filter.v.availability') == '1' && url.searchParams.get('section_id') == '1') || (count_of_search_params == 1 && url.searchParams.get('section_id') == '1')) {
      //do nothing
  }else{
  // Check if the URL already has the availability filter
  
    // Define all shoe size filter parameters to check for
  const shoeSizeFilters = [
    'filter.v.m.custom.women_shoe_size',
    'filter.v.m.custom.men_shoe_size',
    'filter.v.m.custom.kids_shoe_size'
  ];

   // Check if any shoe size filter is active
  const hasAnyShoeSizeFilter = Array.from(url.searchParams.keys()).some(param => 
    shoeSizeFilters.some(filterPrefix => param.includes(filterPrefix))
  );

  // check if any filter has been applied - by checking if parm contains "filter" in the url
  const hasAnyFilter = Array.from(url.searchParams.keys()).some(param => 
    param.includes('filter')
  );


  
  if (hasAnyFilter) {
    // Check if availability filter is already set correctly
    const currentAvailability = url.searchParams.get('filter.v.availability');

        // Only set it if not already set to 1
    if (currentAvailability !== '1') {
      // Set availability filter to only show in-stock items
      url.searchParams.set('filter.v.availability', '1');

      var current_href = event.detail.url.href+"&filter.v.availability=1";
      event.detail.url.href = current_href;
    }
  }

}

//Check if change has been made to the product section
var facetFormBlock = document.querySelector('.shopify-section--main-collection');
  // Check if the element with ID "facet-form" exists
  if (facetFormBlock) {
  
  // Create observer instance
  var observer = new MutationObserver((mutations) => {
      hideAvailabilityFilter();
  });
  
  // Start observing with configuration
  observer.observe(facetFormBlock, { 
    childList: true,
    subtree: true 
  });

}


}, true); 


//Final sale attributes add to cart and line items
document.addEventListener('variant:change', function(event) {

    const formId = event.target.getAttribute('id'); // Get the form ID from the event target

    if (!formId) {
       
        return;
    }

    const newVariant = event.detail.variant; // The new selected variant object
    const productForm = document.getElementById(formId); // Get the specific form

    if (productForm && newVariant) {
        
        const priceInput = productForm.querySelector('input[name="current-variant-price"]');
        const comparePriceInput = productForm.querySelector('input[name="current-variant-compare-at-price"]');

        if (priceInput) {
            priceInput.value = newVariant.price; // Assuming newVariant.price is in cents
        }

        if (comparePriceInput) {
            // newVariant.compare_at_price might be null if not on sale
            comparePriceInput.value = newVariant.compare_at_price || 0; 
        } 
    }
});

document.addEventListener('cart:change', async (event) => {
 
    let cartData = event.detail?.cart; // Prefer cart data from the event if available

    // If cart data is not in the event detail, fetch it.
    // This is a fallback, as well-behaved themes should include it.
    if (!cartData || typeof cartData.items === 'undefined') {
        try {
            const response = await fetch(`${Shopify.routes.root}cart.js`); // Use Shopify.routes.root
            if (!response.ok) {
                return; // Exit if cart data fetch fails
            }
            cartData = await response.json();
        } catch (error) {
            return; // Exit on error
        }
    }

    if (!cartData || typeof cartData.items === 'undefined') {
        return;
    }

    //Check all items in the cart for the _isFinalSale property
    const isAnyItemFinalSale = cartData.items.some(item => {
        // item.properties can be null if no properties exist
        return item.properties && item.properties._isFinalSale === 'Yes';
    });

    //Get the current state of the cart attribute
    const currentCartAttribute = cartData.attributes?.hasFinalSaleItemInOrder; // Can be undefined

    let attributesToUpdate = {};
    let needsCartUpdate = false;

    // Logic to determine if an update is needed
    if (isAnyItemFinalSale) {
        // If there's a final sale item, the attribute should be 'true'
        if (currentCartAttribute !== 'true') {
            attributesToUpdate.hasFinalSaleItemInOrder = 'true'; // Cart attributes are strings
            needsCartUpdate = true;
        }
    } else {
        // If there are NO final sale items, the attribute should be removed (or set to false/null)
        // We check if it currently exists and is 'true' before deciding to remove it
        if (currentCartAttribute === 'true') {
            attributesToUpdate.hasFinalSaleItemInOrder = null; // Setting to null effectively removes it
            needsCartUpdate = true;
        }
    }

    //If an update is needed, call cart/update.js
    if (needsCartUpdate) {
        try {
            const updateResponse = await fetch(`${Shopify.routes.root}cart/update.js`, { // Use Shopify.routes.root
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json' // Good practice to include Accept header
                },
                body: JSON.stringify({
                    attributes: attributesToUpdate
                })
            });

            if (!updateResponse.ok) {
                const errorData = await updateResponse.json();
            } else {
                const updatedCart = await updateResponse.json();
            }
        } catch (error) {
            console.error('Error calling cart/update.js:', error);
        }
    } 
});